import React from 'react';
import { useSelector } from 'react-redux';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import LocalizedLink from 'helpers/LocalizeLink';
import { convert } from 'helpers/util';
import { useNavigate } from 'react-router-dom';
import logo from 'assets/img/logo.svg';

const LearningTrendingWidget = (props) => {
    const navigate = useNavigate();
    const default_view_numbers = 127;
    const auth = useSelector(store => store.auth);
    const { t } = useTranslation();
    const currentDate = new Date().getMonth();

    const getPublish = (trending) => {
        let publishDate = new Date(trending.updated_at).getMonth()
        return (publishDate > currentDate) ? 12 - publishDate + currentDate : currentDate - publishDate
    }

    return (
        <div>
            <p>{t('labels.trending')}</p>
            <div>
                {props.items.map((trending, index) => {
                    return (
                        <div key={'lt_' + index}>
                            <div>
                                <div>
                                    {
                                        trending.img ?
                                            <img alt={'trading'} src={trending.img} /> :
                                            <img alt={'trading'} src={logo} />
                                    }
                                    <LocalizedLink to={'learning/' + trending.id}>
                                        <div>
                                            <div>
                                                {
                                                    !auth ?
                                                        <p>{t('labels.lock')}</p>
                                                        :
                                                        <p>{t('labels.learn')}</p>
                                                }
                                                <div></div>
                                            </div>
                                            <div>
                                                <span>{trending.category}</span>
                                                <span>{t('filter.labels.difficulty')}:<span
                                                    className={'' + trending.level}></span></span>
                                            </div>
                                        </div>
                                    </LocalizedLink>
                                </div>
                                <p onClick={() => { navigate('learning/' + trending.id) }}>{trending.title}</p>
                                <div>
                                    <span>{convert((trending.views > 0) ? trending.views : default_view_numbers)} {t('labels.view', { count: (trending.views > 0) ? trending.views : default_view_numbers })}</span>
                                    <span>{getPublish(trending)} {t('labels.month_ago', { count: getPublish(trending) })}</span>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

LearningTrendingWidget.propTypes = {
    title: PropTypes.string,
    descriptions: PropTypes.string,
    additional_text: PropTypes.string,
    button_text: PropTypes.string,
    path: PropTypes.string,
    img: PropTypes.string,
    position: PropTypes.number,
    widget: PropTypes.string,
    className: PropTypes.string,
    views: PropTypes.number,
    items: PropTypes.array,
}

export default LearningTrendingWidget;
